export class MaximumActiveCampaignsExceededException {}